import "./rayze-console.scss";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import AddCandidatePage from "../AddCandidatePage/AddCandidatePage";
import AddOpenRolesPage from "../AddOpenRoles/AddOpenRolesPage";
import InvoicePage from "../InvoicePage/InvoicePage";
import SelectInvoicePage from "../SelectInvoicePage/SelectInvoicePage";
import AdminPage from "../AdminPage/AdminCRUD";
import SowPage from "../SowPage/SowPage";
import UserAvatar from "../../components/UserAvatar/UserAvatar";
import ProfileModal from "../../components/ProfileModal/ProfileModal";




export default function RayzeConsole() {
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem('activeTab') || "home";
  });
  const [consoleData, setConsoleData] = useState({
    payroll_candidates: 0,
    hired_last_month: 0
  });
  const [activityData, setActivityData] = useState([]);
  const [userRole, setUserRole] = useState(null);
  const [profileModalOpen, setProfileModalOpen] = useState(false);
  const [user, setUser] = useState(() => {
    const sessionUser = sessionStorage.getItem('user');
    if (sessionUser) {
      const userData = JSON.parse(sessionUser);
      return {
        name: userData.name || userData.email,
        email: userData.email
      };
    }
    return null;
  });
  const [candidates, setCandidates] = useState([]);
  const [filteredCandidates, setFilteredCandidates] = useState([]);
  const [filteredInputRequiredCandidates, setFilteredInputRequiredCandidates] = useState([]);
  const [openRoles, setOpenRoles] = useState([]);
  const [filteredOpenRoles, setFilteredOpenRoles] = useState([]);
  const [clients, setClients] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState(() => {
    return localStorage.getItem('selectedClientId') || null;
  });
  const [clientSearch, setClientSearch] = useState(() => {
    const savedClientId = localStorage.getItem('selectedClientId');
    if (savedClientId) {
      const savedClient = clients.find(client => client.id === savedClientId);
      return savedClient ? savedClient.name : '';
    }
    return '';
  });
  
  // Project-related state
  const [projects, setProjects] = useState([]);
  const [isProjectSearchEnabled, setIsProjectSearchEnabled] = useState(false);
  const [selectedProjectIds, setSelectedProjectIds] = useState(() => {
    const saved = localStorage.getItem('selectedProjectIds');
    return saved ? JSON.parse(saved) : [];
  });
  const [projectSearch, setProjectSearch] = useState('');
  const [isProjectDropdownOpen, setIsProjectDropdownOpen] = useState(false);
  const [filters, setFilters] = useState({
    name: '',
    role: '',
    location: '',
    status: '',
    role_desc: '',
    client_name: '',
    role_status: ''
  });
  const [inputRequiredFilters, setInputRequiredFilters] = useState({
    name: '',
    role: '',
    location: ''
  });
  const [openRolesFilters, setOpenRolesFilters] = useState({
    role_desc: ''
  });
  const [showMatchScoreModal, setShowMatchScoreModal] = useState(false);
  const [matchScoreResult, setMatchScoreResult] = useState(null);
  const [showInterviewEvalModal, setShowInterviewEvalModal] = useState(false);
  const [interviewEvalResult, setInterviewEvalResult] = useState(null);
  const [isLoadingEvaluation, setIsLoadingEvaluation] = useState(false);
  const [evaluationStatus, setEvaluationStatus] = useState('');
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [declineFeedback, setDeclineFeedback] = useState('');
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [showMeetingSetupModal, setShowMeetingSetupModal] = useState(false);
  const [meetingSetupFrom, setMeetingSetupFrom] = useState('');
  const [meetingSetupTo, setMeetingSetupTo] = useState('');
  const [meetingSetupSubject, setMeetingSetupSubject] = useState('');
  const [meetingSetupDate, setMeetingSetupDate] = useState('');
  const [meetingSetupStartTime, setMeetingSetupStartTime] = useState('');
  const [meetingSetupEndTime, setMeetingSetupEndTime] = useState('');
  const [meetingSetupTimezone, setMeetingSetupTimezone] = useState(() =>
    Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles'
  );
  const [isCreatingMeeting, setIsCreatingMeeting] = useState(false);
  const [useFastMeetingSetup, setUseFastMeetingSetup] = useState(() => {
    const saved = localStorage.getItem('useFastMeetingSetup');
    return saved !== null ? saved === 'true' : true;
  });
  const [showJDModal, setShowJDModal] = useState(false);
  const [currentJDContent, setCurrentJDContent] = useState('');
  const [interviewSlots, setInterviewSlots] = useState(() => {
    // Calculate default dates (next 3 business days)
    const today = new Date();
    
    // Function to get the nth business day from today
    const getNthBusinessDay = (n) => {
      const date = new Date(today);
      let businessDaysFound = 0;
      
      while (businessDaysFound < n) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) {
          businessDaysFound++;
        }
      }
      
      return date;
    };

    const prio1Date = getNthBusinessDay(1);
    const prio2Date = getNthBusinessDay(2);
    const prio3Date = getNthBusinessDay(3);

    return {
      prio1: { 
        date: prio1Date.toISOString().split('T')[0], 
        time: '09:00', 
        timezone: 'America/Los_Angeles' 
      },
      prio2: { 
        date: prio2Date.toISOString().split('T')[0], 
        time: '08:00', 
        timezone: 'America/Los_Angeles' 
      },
      prio3: { 
        date: prio3Date.toISOString().split('T')[0], 
        time: '09:00', 
        timezone: 'America/Los_Angeles' 
      }
    };
  });
  const [convertedTimes, setConvertedTimes] = useState({
    prio1: '',
    prio2: '',
    prio3: ''
  });
  const [convertingTimes, setConvertingTimes] = useState({
    prio1: false,
    prio2: false,
    prio3: false
  });
  const [candidateEmail, setCandidateEmail] = useState('');
  const [interviewerEmails, setInterviewerEmails] = useState('');
  const [interviewPhone, setInterviewPhone] = useState('');
  const navigate = useNavigate();

  // Loading states for timeout handling
  const [isLoadingHomeData, setIsLoadingHomeData] = useState(false);
  const [isLoadingClientConsole, setIsLoadingClientConsole] = useState(false);

  // Error states for timeout handling
  const [homeDataError, setHomeDataError] = useState(null);
  const [clientConsoleError, setClientConsoleError] = useState(null);

  // Check user role and redirect if unauthorized
  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    if (!user) {
      navigate('/login');
      return;
    }

    const role = user.role;
    const clientId = user.client_id != null ? Number(user.client_id) : null;
    const isOperationsClient1 = role === 'Operations' && clientId === 1;

    if (role !== 'ADMIN' && role !== 'Recruiter' && role !== 'Client' && !isOperationsClient1) {
      navigate('/unauthorized');
      return;
    }

    setUserRole(role);

    // Initialize interview contact fields (phone from user; emails are TO recipients, set when modal opens)
    const user_data = JSON.parse(sessionStorage.getItem('user'));
    setInterviewPhone(user_data?.msg_id || '');

    // Update user state from session
    setUser({
      name: user.name || user.email,
      email: user.email
    });

    // If user is Client, force them to Client Console
    if (role === 'Client') {
      setSelectedClientId(user.client_id);
      setActiveTab("client_console");
      // Enable project search for Client users
      setIsProjectSearchEnabled(true);
    }

    // If user is Recruiter, force them to Timesheets
    if (role === 'Recruiter') {
      setActiveTab("timesheet");
    }

    // Operations (client_id=1): behave like ADMIN, default to client 1
    if (isOperationsClient1) {
      setSelectedClientId(1);
      localStorage.setItem('selectedClientId', '1');
      setActiveTab("home");
      setIsProjectSearchEnabled(true);
    }
  }, [navigate]);

  // Update localStorage when activeTab changes
  useEffect(() => {
    localStorage.setItem('activeTab', activeTab);
  }, [activeTab]);

  // Function to fetch projects for a selected client
  const fetchProjectsForClient = async (clientId) => {
    try {
      const token = sessionStorage.getItem('token');

      // Use the dedicated find_project_names endpoint
      const response = await axios.get(
        `${process.env.REACT_APP_RYZ_SERVER}/find_project_names/${clientId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Convert the array of project names to project objects with IDs
      const projectsArray = response.data.map((name, index) => ({
        id: index + 1,
        name: name
      }));

      setProjects(projectsArray);
      
      // If user is Client, auto-select projects from user.projects field
      if (userRole === 'Client') {
        const userData = JSON.parse(sessionStorage.getItem('user'));
        
        try {
          // Fetch the user's projects from the backend using the correct find_user endpoint
          const userResponse = await axios.get(
            `${process.env.REACT_APP_RYZ_SERVER}/find_user/${userData.id}`,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            }
          );
          
          const userProjects = userResponse.data?.projects || '';
          
          if (userProjects.trim()) {
            // Split comma-separated project names and trim whitespace
            const userProjectNames = userProjects.split(',').map(name => name.trim());
            
            // Find matching project IDs from the fetched projects
            const matchingProjectIds = projectsArray
              .filter(project => userProjectNames.includes(project.name))
              .map(project => project.id);
            
            if (matchingProjectIds.length > 0) {
              setSelectedProjectIds(matchingProjectIds);
              localStorage.setItem('selectedProjectIds', JSON.stringify(matchingProjectIds));
              
              // Set the project search display to show selected project names
              const selectedProjectNames = projectsArray
                .filter(project => matchingProjectIds.includes(project.id))
                .map(project => project.name);
              
              setProjectSearch(selectedProjectNames.join(', '));
            }
          }
        } catch (userFetchError) {
          console.error('Error fetching user projects from backend:', userFetchError);
          // Fallback: select all projects for Client user
          const allProjectIds = projectsArray.map(project => project.id);
          setSelectedProjectIds(allProjectIds);
          localStorage.setItem('selectedProjectIds', JSON.stringify(allProjectIds));
          setProjectSearch(projectsArray.map(project => project.name).join(', '));
        }
      }
    } catch (error) {
      console.error('Error fetching projects for client:', error);
      // Let axios interceptor handle the error and redirect to login
      setProjects([]);
    }
  };

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, []);

  // Fetch data for home tab
  useEffect(() => {
    const fetchHomeData = async () => {
      if (activeTab !== "home") return;

      setIsLoadingHomeData(true);
      setHomeDataError(null);

      try {
        const token = sessionStorage.getItem('token');
        const user_data = JSON.parse(sessionStorage.getItem('user'));
        const user_role = user_data.role;
        const client_id = user_data.client_id;
        const user_id = user_data.id;

        // Get selected project names
        const selectedProjectNames = projects
          .filter(project => selectedProjectIds.includes(project.id))
          .map(project => project.name);

        const [consoleResponse, activityResponse] = await Promise.all([
          axios.get(
            `${process.env.REACT_APP_RYZ_SERVER}/get_console_data`,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
              params: selectedProjectNames.length > 0 ? {
                'project_list[]': selectedProjectNames
              } : {}
            }
          ),
          axios.get(
            `${process.env.REACT_APP_RYZ_SERVER}/get_console_activity`,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            }
          )
        ]);
        setConsoleData(consoleResponse.data);
        setActivityData(activityResponse.data);
        setHomeDataError(null);
      } catch (error) {
        console.error('Error fetching home data:', error);

        // Handle timeout errors and other errors by redirecting to login
        setHomeDataError({
          type: 'session_expired',
          message: 'Your session has expired. Please log in again.'
        });
      } finally {
        setIsLoadingHomeData(false);
      }
    };

    fetchHomeData();
  }, [activeTab, selectedProjectIds]); // Re-run when activeTab or selectedProjectIds change

  // Fetch clients first - only for non-client users and client_console tab
  useEffect(() => {
    const fetchClients = async () => {
      // Don't fetch if:
      // 1. User is a Client
      // 2. Not in client_console tab
      if (userRole === 'Client' || activeTab !== "client_console") return;

      try {
        const token = sessionStorage.getItem('token');
        const response = await axios.get(
          `${process.env.REACT_APP_RYZ_SERVER}/list_clients`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // Filter clients to only show those with client_type = 'Client'
        const filteredClients = response.data.filter(client => client.client_type === 'Client');
        setClients(filteredClients);
      } catch (error) {
        console.error('Error fetching clients:', error);
        // Let axios interceptor handle the error and redirect to login
      }
    };

    fetchClients();
  }, [userRole, activeTab]);

  // Fetch data for client_console tab
  useEffect(() => {
    const fetchClientConsoleData = async () => {
      // Don't fetch if:
      // 1. Not in client_console tab
      if (activeTab !== "client_console") return;

      setIsLoadingClientConsole(true);
      setClientConsoleError(null);

      try {
        const token = sessionStorage.getItem('token');
        const user_data = JSON.parse(sessionStorage.getItem('user'));
        const user_role = user_data.role;
        const user_id = user_data.id;
        const client_id = selectedClientId || user_data.client_id;
        // console.log('client_id', client_id);
        //console.log('process.env.REACT_APP_RYZ_SENDMAIL', process.env.REACT_APP_RYZ_SENDMAIL, `${process.env.REACT_APP_RYZ_SENDMAIL}`);

        // Get selected project names
        const selectedProjectNames = projects
          .filter(project => selectedProjectIds.includes(project.id))
          .map(project => project.name);

        // If no client is selected and user is not a Client, show all clients data
        if (!selectedClientId && user_role !== 'Client') {
          // Fetch all candidates and roles from all clients
          const [activityResponse, allCandidatesResponse, allRolesResponse] = await Promise.all([
            axios.get(
              `${process.env.REACT_APP_RYZ_SERVER}/get_console_activity`,
              {
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${token}`,
                },
              }
            ),
            axios.get(`${process.env.REACT_APP_RYZ_SERVER}/list_candidates`, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
              params: {
                inp_recruiter_id: user_role === 'ADMIN' ? 1 : user_id
              }
            }),
            axios.get(`${process.env.REACT_APP_RYZ_SERVER}/list_open_roles`, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              }
            })
          ]);

          // Set empty console data for "all clients" view
          setConsoleData({
            total_active_eng: 0,
            total_active_eng_last30: 0,
            submit_client_cvs: 0,
            submit_client_cvs_last30: 0,
            active_client_roles: 0,
            active_client_roles_last30: 0,
            hired_client_cvs: 0,
            hired_client_cvs_last30: 0
          });
          setActivityData(activityResponse.data);

          // Filter candidates to only show active statuses
          const activeCandidates = allCandidatesResponse.data.filter(candidate =>
            ['Submitted', 'Interview Requested', 'Interview Confirmed', 'Ready to Hire', 'Hired'].includes(candidate.status)
          );
          setCandidates(activeCandidates);
          setFilteredCandidates(activeCandidates);

          // Filter roles to only show open roles
          const openRoles = allRolesResponse.data.filter(role => role.status === 'Open');
          setOpenRoles(openRoles);
          setFilteredOpenRoles(openRoles);
          return;
        }

        // Original code for when a client is selected
        const [consoleResponse, activityResponse, candidatesResponse, openRolesResponse] = await Promise.all([
          axios.get(
            `${process.env.REACT_APP_RYZ_SERVER}/get_console_data_by_client/${client_id}`,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
              params: selectedProjectNames.length > 0 ? {
                'project_list[]': selectedProjectNames
              } : {}
            }
          ),
          axios.get(
            `${process.env.REACT_APP_RYZ_SERVER}/get_console_activity`,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            }
          ),
          axios.get(`${process.env.REACT_APP_RYZ_SERVER}/get_console_candidates_by_client/${client_id}`, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            params: selectedProjectNames.length > 0 ? {
              'project_list[]': selectedProjectNames
            } : {}
          }),
          axios.get(`${process.env.REACT_APP_RYZ_SERVER}/get_console_open_roles_by_client/${client_id}`, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            params: selectedProjectNames.length > 0 ? {
              'project_list[]': selectedProjectNames
            } : {}
          })
        ]);



        //console.log('consoleResponse.data', consoleResponse.data);
        setConsoleData(consoleResponse.data);
        setActivityData(activityResponse.data);
        // Data loaded successfully
        console.log('candidatesResponse.data', candidatesResponse.data);
        setCandidates(candidatesResponse.data);
        setFilteredCandidates(candidatesResponse.data);
        setOpenRoles(openRolesResponse.data);
        setFilteredOpenRoles(openRolesResponse.data);
        setClientConsoleError(null);
      } catch (error) {
        console.error('Error fetching client console data:', error);

        // Handle timeout errors and other errors
        setClientConsoleError({
          type: 'session_expired',
          message: 'Your session has expired. Please log in again.'
        });
      } finally {
        setIsLoadingClientConsole(false);
      }
    };

    fetchClientConsoleData();
  }, [activeTab, userRole, selectedClientId, selectedProjectIds]);

  // Initialize project search if a client is already selected
  useEffect(() => {
    if (selectedClientId) {
      fetchProjectsForClient(selectedClientId);
      setIsProjectSearchEnabled(true);
    }
  }, [selectedClientId]);

  // Handle initial project selection from localStorage when projects are loaded
  useEffect(() => {
    // Skip this for Client users as they get all projects selected by default
    if (userRole === 'Client') return;
    
    const savedProjectIds = localStorage.getItem('selectedProjectIds');
    if (savedProjectIds && projects.length > 0) {
      const parsedIds = JSON.parse(savedProjectIds);
      const validIds = parsedIds.filter(id => 
        projects.some(project => project.id === id)
      );
      if (validIds.length > 0) {
        setSelectedProjectIds(validIds);
        const selectedProjectNames = projects
          .filter(project => validIds.includes(project.id))
          .map(project => project.name);
        setProjectSearch(selectedProjectNames.join(', '));
      }
    }
  }, [projects, userRole]);

  // Close project dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const projectSearchElement = document.querySelector('.project-search');
      if (projectSearchElement && !projectSearchElement.contains(event.target)) {
        closeProjectDropdown();
      }
    };

    if (isProjectDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isProjectDropdownOpen]);

  // Add filter effect
  useEffect(() => {
    let filtered = candidates;
    
    // Apply filters
    filtered = filtered.filter(candidate => {
      return Object.keys(filters).every(key => {
        if (!filters[key]) return true;
        const value = candidate[key]?.toString().toLowerCase() || '';
        return value.includes(filters[key].toLowerCase());
      });
    });
    
    // Project filtering is handled by the backend API
    // No additional frontend filtering needed
    

    setFilteredCandidates(filtered);
  }, [filters, candidates, selectedProjectIds]);

  // Add input required filter effect
  useEffect(() => {
    let filtered = candidates;
    
    // Apply input required filters
    filtered = filtered.filter(candidate => {
      return Object.keys(inputRequiredFilters).every(key => {
        if (!inputRequiredFilters[key]) return true;
        const value = candidate[key]?.toString().toLowerCase() || '';
        return value.includes(inputRequiredFilters[key].toLowerCase());
      });
    });
    
    // Project filtering is handled by the backend API
    // No additional frontend filtering needed
    

    setFilteredInputRequiredCandidates(filtered);
  }, [inputRequiredFilters, candidates, selectedProjectIds]);

  // Add open roles filter effect
  useEffect(() => {
    let filtered = openRoles;
    
    // Apply filters
    filtered = filtered.filter(role => {
      return Object.keys(openRolesFilters).every(key => {
        if (!openRolesFilters[key]) return true;
        const value = role[key]?.toString().toLowerCase() || '';
        return value.includes(openRolesFilters[key].toLowerCase());
      });
    });
    
    // Project filtering is handled by the backend API
    // No additional frontend filtering needed
    

    setFilteredOpenRoles(filtered);
  }, [openRolesFilters, openRoles, selectedProjectIds]);


  // Client selection is now handled by handleClientChange

  // Project selection is now handled by handleProjectChange

  const handleFilterChange = (e, field) => {
    setFilters(prev => ({
      ...prev,
      [field]: e.target.value
    }));
  };

  const handleInputRequiredFilterChange = (e, field) => {
    setInputRequiredFilters(prev => ({
      ...prev,
      [field]: e.target.value
    }));
  };

  const handleOpenRolesFilterChange = (e, field) => {
    setOpenRolesFilters(prev => ({
      ...prev,
      [field]: e.target.value
    }));
  };

  const handleClientChange = (e) => {
    const clientId = e.target.value;
    setSelectedClientId(clientId);
    
    if (clientId) {
      localStorage.setItem('selectedClientId', clientId);
      // Find the client name for display
      const selectedClient = clients.find(client => client.id === parseInt(clientId));
      setClientSearch(selectedClient ? selectedClient.name : '');
      // Enable project search and fetch projects for this client
      fetchProjectsForClient(clientId);
      setIsProjectSearchEnabled(true);
      // Reset project selection
      setSelectedProjectIds([]);
      setProjectSearch('');
      setIsProjectDropdownOpen(false);
      localStorage.removeItem('selectedProjectIds');
    } else {
      localStorage.removeItem('selectedClientId');
      setClientSearch('');
      setProjects([]);
      setIsProjectSearchEnabled(false);
      setSelectedProjectIds([]);
      setProjectSearch('');
      setIsProjectDropdownOpen(false);
      localStorage.removeItem('selectedProjectIds');
    }
  };

  const handleProjectChange = (e) => {
    const projectId = parseInt(e.target.value);
    const isChecked = e.target.checked;
    
    let newSelectedProjectIds;
    if (isChecked) {
      // Add project to selection
      newSelectedProjectIds = [...selectedProjectIds, projectId];
    } else {
      // Remove project from selection
      newSelectedProjectIds = selectedProjectIds.filter(id => id !== projectId);
    }
    
    setSelectedProjectIds(newSelectedProjectIds);
    localStorage.setItem('selectedProjectIds', JSON.stringify(newSelectedProjectIds));
    
    // Update project search display
    if (newSelectedProjectIds.length > 0) {
      const selectedProjectNames = projects
        .filter(project => newSelectedProjectIds.includes(project.id))
        .map(project => project.name);
      setProjectSearch(selectedProjectNames.join(', '));
    } else {
      setProjectSearch('');
    }
  };

  const toggleProjectDropdown = () => {
    if (isProjectSearchEnabled || userRole === 'Client') {
      setIsProjectDropdownOpen(!isProjectDropdownOpen);
    }
  };

  const closeProjectDropdown = () => {
    setIsProjectDropdownOpen(false);
  };

  const getActivityIcon = (title) => {
    switch (title) {
      case 'New Hire':
        return 'H';
      case 'Candidate Submitted':
        return 'C';
      case 'New Open Role':
        return 'R';
      default:
        return '•';
    }
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleProfileSave = (profileData) => {
    setUser({
      name: profileData.name || profileData.email,
      email: profileData.email
    });
  };

  const handleAvatarClick = () => {
    setProfileModalOpen(true);
  };

  const handleMatchScoreClick = (e, matchScore) => {
    e.stopPropagation();
    setMatchScoreResult(matchScore);
    setShowMatchScoreModal(true);
  };

  const handleCloseMatchScoreModal = () => {
    setShowMatchScoreModal(false);
    setMatchScoreResult(null);
  };

  const handleInterviewEvaluate = async (e, candidate) => {
    e.stopPropagation();

    // Check if test_score exists (already evaluated)
    if (candidate.test_score) {
      setInterviewEvalResult(candidate.test_score);
      setShowInterviewEvalModal(true);
      return;
    }

    // Check if event_id exists
    if (!candidate.event_id) {
      setShowInterviewEvalModal(true);
      setIsLoadingEvaluation(false);
      setEvaluationStatus('No interview scheduled yet. Please schedule an interview first.');
      return;
    }

    // Show modal with loading state
    setShowInterviewEvalModal(true);
    setIsLoadingEvaluation(true);
    setEvaluationStatus('Fetching interview transcript...');

    try {
      const token = sessionStorage.getItem('token');

      // Step 1: Fetch transcript from SENDMAIL API
      const transcriptResponse = await axios.get(
        `${process.env.REACT_APP_RYZ_SENDMAIL}/transcript_notes/${candidate.event_id}`
      );

      // Check if transcript has content
      if (!transcriptResponse.data.notes || transcriptResponse.data.notes.trim().length === 0) {
        setEvaluationStatus('No transcript available yet. The interview may not have been recorded or notes have not been generated.');
        setIsLoadingEvaluation(false);
        return;
      }

      setEvaluationStatus('Evaluating interview transcript...');

      // Step 2: Call eval_interview endpoint
      const evalResponse = await axios.post(
        `${process.env.REACT_APP_RYZ_SERVER}/eval_interview`,
        { transcript: transcriptResponse.data.notes },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
      );

      setInterviewEvalResult(evalResponse.data.evaluation);
      setIsLoadingEvaluation(false);
      setEvaluationStatus('');

    } catch (error) {
      console.error('Error evaluating interview:', error);

      // Parse error message for better user feedback
      let errorMessage = 'An unexpected error occurred.';

      if (error.response?.status === 404) {
        if (error.response?.data?.detail?.includes('attachments')) {
          errorMessage = 'Interview transcript not found. The Google Meet recording may not have generated notes yet. Please try again later or check Google Drive manually.';
        } else if (error.response?.data?.detail?.includes('Not Found')) {
          errorMessage = 'Interview event not found. The meeting may have been deleted or the event ID is invalid.';
        } else {
          errorMessage = 'Interview transcript not available. Please ensure the interview has been completed and recorded.';
        }
      } else if (error.response?.status === 401 || error.response?.status === 403) {
        errorMessage = 'Authentication error. Please log in again.';
      } else if (error.response?.status === 500) {
        errorMessage = 'Server error occurred. Please try again later or contact support.';
      } else if (error.message?.includes('Network Error')) {
        errorMessage = 'Network error. Please check your connection and try again.';
      } else if (error.response?.data?.detail) {
        // Clean up technical error details
        const detail = error.response.data.detail;
        if (detail.includes('HttpError')) {
          errorMessage = 'Google Calendar/Drive error. The interview may not have recording notes yet.';
        } else {
          errorMessage = detail;
        }
      }

      setEvaluationStatus(errorMessage);
      setIsLoadingEvaluation(false);
    }
  };

  const handleCloseInterviewEvalModal = () => {
    setShowInterviewEvalModal(false);
    setInterviewEvalResult(null);
    setIsLoadingEvaluation(false);
    setEvaluationStatus('');
  };

  const handleJDClick = async (e, jdLink) => {
    e.stopPropagation();
    
    if (!jdLink) return;
    
    // Check if it's a PDF link - use more comprehensive detection
    const isPDF = jdLink.toLowerCase().includes('.pdf') || 
                  jdLink.toLowerCase().includes('pdf') ||
                  jdLink.toLowerCase().match(/\.pdf(\?|$|#)/);
    
    if (isPDF) {
      // For PDF files, open in new tab as before and exit immediately
      window.open(jdLink, '_blank');
      return;
    }
    
    // Only proceed with modal logic for non-PDF files
    try {
      // For other links, fetch the content
      const response = await fetch(jdLink);
      
      // Check content type header as additional safety
      const contentType = response.headers.get('content-type') || '';
      if (contentType.includes('application/pdf')) {
        // Content type indicates PDF, open in new tab
        window.open(jdLink, '_blank');
        return;
      }
      
      const content = await response.text();
      
      // Check if the content is HTML with JSON
      if (content.includes('<html>') && content.includes('<body>')) {
        // Extract JSON from HTML body
        const jsonMatch = content.match(/<body>(.*?)<\/body>/s);
        if (jsonMatch) {
          try {
            const jsonString = jsonMatch[1].trim();
            const jsonData = JSON.parse(jsonString);
            
            // Format the JSON data into readable HTML
            const formattedHTML = formatJDJSON(jsonData);
            setCurrentJDContent(formattedHTML);
            setShowJDModal(true);
            
          } catch (jsonError) {
            console.error('Error parsing JSON from HTML:', jsonError);
            // Fallback: display raw content
            setCurrentJDContent(content);
            setShowJDModal(true);
          }
        } else {
          // No JSON found, display HTML as is
          setCurrentJDContent(content);
          setShowJDModal(true);
        }
      } else {
        // Regular HTML or other content
        setCurrentJDContent(content);
        setShowJDModal(true);
      }
    } catch (error) {
      console.error('Error fetching JD content:', error);
      // Fallback to opening in new tab
      window.open(jdLink, '_blank');
    }
  };

  const formatJDJSON = (jsonData) => {
    return `
      <div style="font-family: Arial, sans-serif; line-height: 1.6; padding: 20px;">
        <h1 style="color: #2563eb; border-bottom: 2px solid #2563eb; padding-bottom: 10px;">
          ${jsonData.role_name || 'Job Description'}
        </h1>
        
        ${jsonData.background ? `
          <section style="margin-bottom: 25px;">
            <h2 style="color: #1f2937; margin-bottom: 10px;">Background</h2>
            <p style="color: #4b5563;">${jsonData.background}</p>
          </section>
        ` : ''}
        
        ${jsonData.role_desc ? `
          <section style="margin-bottom: 25px;">
            <h2 style="color: #1f2937; margin-bottom: 10px;">Role Description</h2>
            <p style="color: #4b5563;">${jsonData.role_desc}</p>
          </section>
        ` : ''}
        
        ${jsonData.responsibilities && jsonData.responsibilities.length > 0 ? `
          <section style="margin-bottom: 25px;">
            <h2 style="color: #1f2937; margin-bottom: 10px;">Key Responsibilities</h2>
            <ul style="color: #4b5563; padding-left: 20px;">
              ${jsonData.responsibilities.map(item => `<li style="margin-bottom: 8px;">${item}</li>`).join('')}
            </ul>
          </section>
        ` : ''}
        
        ${jsonData.candidate_requirements && jsonData.candidate_requirements.length > 0 ? `
          <section style="margin-bottom: 25px;">
            <h2 style="color: #1f2937; margin-bottom: 10px;">Requirements</h2>
            <ul style="color: #4b5563; padding-left: 20px;">
              ${jsonData.candidate_requirements.map(item => `<li style="margin-bottom: 8px;">${item}</li>`).join('')}
            </ul>
          </section>
        ` : ''}
        
        
        ${jsonData.must_have && jsonData.must_have.length > 0 ? `
          <section style="margin-bottom: 25px;">
            <h2 style="color: #dc2626; margin-bottom: 10px;">Must Have Skills</h2>
            <ul style="color: #4b5563; padding-left: 20px;">
              ${jsonData.must_have.map(item => `<li style="margin-bottom: 8px; font-weight: 500;">${item}</li>`).join('')}
            </ul>
          </section>
        ` : ''}
        
        ${jsonData.nice_to_have && jsonData.nice_to_have.length > 0 ? `
          <section style="margin-bottom: 25px;">
            <h2 style="color: #059669; margin-bottom: 10px;">Nice to Have</h2>
            <ul style="color: #4b5563; padding-left: 20px;">
              ${jsonData.nice_to_have.map(item => `<li style="margin-bottom: 8px;">${item}</li>`).join('')}
            </ul>
          </section>
        ` : ''}
        
        ${jsonData.technical_skills && jsonData.technical_skills.length > 0 ? `
          <section style="margin-bottom: 25px;">
            <h2 style="color: #1f2937; margin-bottom: 10px;">Technical Skills</h2>
            <div style="display: flex; flex-wrap: wrap; gap: 8px;">
              ${jsonData.technical_skills.map(skill => `
                <span style="background-color: #e5e7eb; color: #374151; padding: 4px 8px; border-radius: 4px; font-size: 14px;">
                  ${skill}
                </span>
              `).join('')}
            </div>
          </section>
        ` : ''}
      </div>
    `;
  };

  const handleCloseJDModal = () => {
    setShowJDModal(false);
    setCurrentJDContent('');
  };

  const handleDeclineClick = (e, candidate) => {
    e.stopPropagation();
    setSelectedCandidate(candidate);
    setShowDeclineModal(true);
  };

  const handleDeclineConfirm = async () => {
    if (!declineFeedback) return;

    try {
      const token = sessionStorage.getItem('token');
      const user_data = JSON.parse(sessionStorage.getItem('user'));
      //const client_id = user_data.client_id;
      const client_id = selectedClientId || user_data.client_id;

      // Update candidate status
      await axios.put(
        `${process.env.REACT_APP_RYZ_SERVER}/update_candidate/${selectedCandidate.id}`,
        {
          status: 'Declined',
          feedback: declineFeedback
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Update submit CV status using the correct endpoint and parameter
      const submitCVRoleData = {
        status: 'Declined'
      };
      
      // console.log('Sending submit CV role data:', submitCVRoleData);
      
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_RYZ_SERVER}/update_submit_cvrole/${selectedCandidate.submit_cvrole_id}`,
          submitCVRoleData,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // console.log('Submit CV role update response:', response.data);
      } catch (error) {
        console.error('Error details:', error.response?.data);
        throw error;
      }

      // Get selected project names
      const selectedProjectNames = projects
        .filter(project => selectedProjectIds.includes(project.id))
        .map(project => project.name);

      // Refresh the candidates list
      const responseCandidates = await axios.get(
        `${process.env.REACT_APP_RYZ_SERVER}/get_console_candidates_by_client/${client_id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          params: selectedProjectNames.length > 0 ? {
            'project_list[]': selectedProjectNames
          } : {}
        }
      );
      setCandidates(responseCandidates.data);
      setFilteredCandidates(responseCandidates.data);

      // Close modal and reset state
      setShowDeclineModal(false);
      setSelectedCandidate(null);
      setDeclineFeedback('');
    } catch (error) {
      console.error('Error declining candidate:', error);
    }
  };

  const handleProceedClick = async (e, candidate) => {
    e.stopPropagation();
    
    if (candidate.status === 'Submitted' || candidate.status === 'Interview Requested' || candidate.status === 'Interview Confirmed') {
      setSelectedCandidate(candidate);
      const userData = JSON.parse(sessionStorage.getItem('user'));
      setCandidateEmail(candidate.email || '');
      setInterviewerEmails(userData?.email ? userData.email : '');
      if (useFastMeetingSetup) {
        const toList = [candidate.email, userData?.email].filter(Boolean);
        setMeetingSetupFrom(userData?.email || '');
        setMeetingSetupTo(toList.join(', '));
        setMeetingSetupSubject(`Interview with ${candidate.name}`);
        setMeetingSetupDate(new Date().toISOString().split('T')[0]);
        setMeetingSetupStartTime('09:00');
        setMeetingSetupEndTime('10:00');
        setMeetingSetupTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles');
      }
      setShowScheduleModal(true);
      return;
    }
    
    // let newStatus;
    // if (candidate.status.includes('Confirmed')) {
    //   newStatus = 'Ready to Hire';
    // } else {
    //   return; // Invalid status transition
    // }

    // // Use the helper function for other status transitions
    // handleProceedWithStatus(candidate, newStatus);
  };

  const handleCloseDeclineModal = () => {
    setShowDeclineModal(false);
    setSelectedCandidate(null);
    setDeclineFeedback('');
  };

  const handleOpenMeetingSetupModal = () => {
    setMeetingSetupFrom(user?.email || '');
    setMeetingSetupTo('');
    setMeetingSetupSubject('');
    setMeetingSetupDate(new Date().toISOString().split('T')[0]);
    setMeetingSetupStartTime('09:00');
    setMeetingSetupEndTime('10:00');
    setMeetingSetupTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles');
    setShowMeetingSetupModal(true);
  };

  const handleCloseMeetingSetupModal = () => {
    setShowMeetingSetupModal(false);
  };

  const handleCreateMeeting = async () => {
    const toEmails = meetingSetupTo.trim().split(',').map(e => e.trim()).filter(Boolean);
    if (!toEmails.length) {
      alert('Please enter at least one participant email in the To field.');
      return;
    }
    if (!meetingSetupDate || !meetingSetupStartTime || !meetingSetupEndTime) {
      alert('Please fill in Date, Start time, and End time.');
      return;
    }
    if (!process.env.REACT_APP_RYZ_SENDMAIL) {
      alert('Sendmail service is not configured. Set REACT_APP_RYZ_SENDMAIL.');
      return;
    }
    setIsCreatingMeeting(true);
    const [startH, startM] = meetingSetupStartTime.split(':').map(Number);
    const [endH, endM] = meetingSetupEndTime.split(':').map(Number);
    const durationMinutes = (endH * 60 + endM) - (startH * 60 + startM);
    const durationHours = Math.max(1, Math.ceil(durationMinutes / 60));
    const eventDatetime = `${meetingSetupDate}T${meetingSetupStartTime} ${meetingSetupTimezone}`;
    const subjectText = meetingSetupSubject.trim() || 'Meeting';
    const payload = {
      to_email: toEmails.join(', '),
      to_name: toEmails[0].split('@')[0],
      subject: subjectText,
      event_summary: subjectText,
      event_datetime: eventDatetime,
      event_duration_hours: durationHours
    };
    if (process.env.REACT_APP_SENDMAIL_CC) {
      payload.cc_email = process.env.REACT_APP_SENDMAIL_CC;
    }
    try {
      await axios.post(
        `${process.env.REACT_APP_RYZ_SENDMAIL}/send_invite`,
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      );
      handleCloseMeetingSetupModal();
      setShowScheduleModal(false);
      if (selectedCandidate) {
        handleProceedWithStatus(selectedCandidate, 'Interview Requested');
      }
      setSelectedCandidate(null);
      alert('Calendar invite sent successfully!');
    } catch (error) {
      const msg = error.response?.data?.detail || error.response?.data?.message || error.message || 'Failed to send calendar invite';
      console.error('Create meeting error:', error);
      alert(`Failed to send calendar invite: ${msg}`);
    } finally {
      setIsCreatingMeeting(false);
    }
  };

  const isMeetingSetupValid = () =>
    meetingSetupTo.trim().length > 0 &&
    meetingSetupDate &&
    meetingSetupStartTime &&
    meetingSetupEndTime;

  const handleCloseScheduleModal = () => {
    setShowScheduleModal(false);
    setSelectedCandidate(null);
    
    // Reset to default interview slots
    const today = new Date();
    
    // Function to get the nth business day from today
    const getNthBusinessDay = (n) => {
      const date = new Date(today);
      let businessDaysFound = 0;
      
      while (businessDaysFound < n) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) {
          businessDaysFound++;
        }
      }
      
      return date;
    };

    const prio1Date = getNthBusinessDay(1);
    const prio2Date = getNthBusinessDay(2);
    const prio3Date = getNthBusinessDay(3);

    setConvertedTimes({
      prio1: '',
      prio2: '',
      prio3: ''
    });
    setConvertingTimes({
      prio1: false,
      prio2: false,
      prio3: false
    });
    
    // Reset interview contact fields (emails cleared; phone from user)
    const user = JSON.parse(sessionStorage.getItem('user'));
    setCandidateEmail('');
    setInterviewerEmails('');
    setInterviewPhone(user?.msg_id || '');
  };

  const handleInterviewSlotChange = (priority, field, value) => {
    setInterviewSlots(prev => ({
      ...prev,
      [priority]: {
        ...prev[priority],
        [field]: value
      }
    }));
  };

  const convertTimeForCandidate = async (priority, date, time, timezone) => {
    if (!date || !time || !selectedCandidate?.location) return;
    if (!process.env.REACT_APP_RYZ_SENDMAIL) return;
    const loc = selectedCandidate.location.trim();
    if (!loc || loc.toLowerCase() === 'remote') return;

    setConvertingTimes(prev => ({ ...prev, [priority]: true }));
    setConvertedTimes(prev => ({ ...prev, [priority]: null }));

    try {
      const token = sessionStorage.getItem('token');
      const timeStr = `${date} ${time}`;

      const getCityFromTimezone = (tz) => {
        const cityMap = {
          'America/New_York': 'New York',
          'America/Chicago': 'Chicago',
          'America/Denver': 'Denver',
          'America/Los_Angeles': 'Los Angeles',
          'America/Phoenix': 'Phoenix',
          'America/Bogota': 'Bogota',
          'America/Mexico_City': 'Mexico City',
          'Europe/London': 'London',
          'Europe/Paris': 'Paris',
          'Asia/Tokyo': 'Tokyo',
          'Asia/Shanghai': 'Shanghai',
          'Asia/Singapore': 'Singapore',
          'Asia/Kolkata': 'Mumbai',
          'Australia/Sydney': 'Sydney',
          'Australia/Melbourne': 'Melbourne',
          'Australia/Perth': 'Perth'
        };
        return cityMap[tz] || tz.split('/').pop().replace('_', ' ');
      };

      const payload = {
        from_city: getCityFromTimezone(timezone),
        time_str: timeStr,
        fmt: "%Y-%m-%d %H:%M"
      };
      if (loc.includes('/')) {
        payload.browser_timezone = loc;
      } else {
        payload.to_city = loc;
      }

      const response = await axios.post(
        `${process.env.REACT_APP_RYZ_SENDMAIL}/convert_time`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status === 'success') {
        setConvertedTimes(prev => ({
          ...prev,
          [priority]: response.data.converted_time
        }));
      }
    } catch (error) {
      console.error('Error converting time:', error);
      setConvertedTimes(prev => ({ ...prev, [priority]: null }));
    } finally {
      setConvertingTimes(prev => ({ ...prev, [priority]: false }));
    }
  };

  // Update converted times when interview slots change
  useEffect(() => {
    if (!selectedCandidate?.location) return;
    
    Object.keys(interviewSlots).forEach(priority => {
      const slot = interviewSlots[priority];
      if (slot.date && slot.time && slot.timezone) {
        convertTimeForCandidate(priority, slot.date, slot.time, slot.timezone);
      }
    });
  }, [interviewSlots, selectedCandidate?.location]);

  const isScheduleButtonEnabled = () => {
    return interviewSlots.prio1.date && interviewSlots.prio1.time &&
           interviewSlots.prio2.date && interviewSlots.prio2.time &&
           interviewSlots.prio3.date && interviewSlots.prio3.time;
  };

  const handleScheduleInterview = async () => {
    const candidateToEmail = candidateEmail.trim() || selectedCandidate.email;
    const interviewersList = interviewerEmails.trim().split(',').map(e => e.trim()).filter(Boolean);
    const invite_emails = [candidateToEmail, ...interviewersList].filter(Boolean).join(', ');

    // Validate that submit_cvrole_id exists
    if (!selectedCandidate.submit_cvrole_id) {
      console.error('Error: selectedCandidate.submit_cvrole_id is missing', selectedCandidate);
      alert('Error: Cannot schedule interview - missing submission ID. Please refresh and try again.');
      return;
    }

    const scheduleData = {
      timeslot1: `${interviewSlots.prio1.date}T${interviewSlots.prio1.time} ${interviewSlots.prio1.timezone}`,
      timeslot2: `${interviewSlots.prio2.date}T${interviewSlots.prio2.time} ${interviewSlots.prio2.timezone}`,
      timeslot3: `${interviewSlots.prio3.date}T${interviewSlots.prio3.time} ${interviewSlots.prio3.timezone}`,
      invite_emails: invite_emails,
      candidate_name: selectedCandidate.name,
      candidate_email: selectedCandidate.email,
      candidate_phone: selectedCandidate.phone,
      submit_cvrole_id: selectedCandidate.submit_cvrole_id,
      interview_id: selectedCandidate.submit_cvrole_id,
      client_phone: interviewPhone,
      client_id: selectedClientId
    };
    try {
      console.log('Interview schedule data:', JSON.stringify(scheduleData));
      const response = await axios.post(
        `${process.env.REACT_APP_RYZ_SERVER}/submit_interview_timeslot`,
        scheduleData,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          },
        }
      );
      scheduleData.content = response.data.html;
      scheduleData.interview_id = response.data.interview_id;
      scheduleData.subject = "Rayze Interview Schedule - Please Confirm";

      try {
        const emailPayload = {
          to_email: candidateToEmail,
          to_name: selectedCandidate.name,
          cc_email: process.env.REACT_APP_SENDMAIL_CC,
          subject: "Interview Schedule - Please Confirm",
          content: response.data.html,
          from_email: process.env.REACT_APP_SENDMAIL_FROM,
          attach_pdf: true
        };
        if (process.env.REACT_APP_SENDMAIL_TEST) {
          emailPayload.to_email = process.env.REACT_APP_SENDMAIL_TEST;
        }
        if (process.env.REACT_APP_RYZ_SENDMAIL) {
          await axios.post(
            `${process.env.REACT_APP_RYZ_SENDMAIL}/send_html_email`,
            emailPayload,
            { headers: { 'Content-Type': 'application/json' } }
          );
        }
      } catch (emailError) {
        console.error('Error sending email:', emailError);
      }

      handleCloseScheduleModal();
      handleProceedWithStatus(selectedCandidate, 'Interview Requested');
    } catch (error) {
      const msg = error.response?.data?.detail || error.response?.data?.message || error.message || 'Failed to schedule interview';
      console.error('Schedule interview error:', error);
      alert(`Failed to schedule interview: ${msg}`);
    }
  };

  const handleProceedWithStatus = async (candidate, newStatus) => {
    try {
      const token = sessionStorage.getItem('token');
      const user_data = JSON.parse(sessionStorage.getItem('user'));
      const client_id = selectedClientId || user_data.client_id;

      // Update candidate status
      await axios.put(
        `${process.env.REACT_APP_RYZ_SERVER}/update_candidate/${candidate.id}`,
        {
          status: newStatus
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Update submit CV status
      await axios.put(
        `${process.env.REACT_APP_RYZ_SERVER}/update_submit_cvrole/${candidate.submit_cvrole_id}`,
        {
          status: newStatus
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Get selected project names
      const selectedProjectNames = projects
        .filter(project => selectedProjectIds.includes(project.id))
        .map(project => project.name);

      // Refresh the candidates list
      const response = await axios.get(
        `${process.env.REACT_APP_RYZ_SERVER}/get_console_candidates_by_client/${client_id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          params: selectedProjectNames.length > 0 ? {
            'project_list[]': selectedProjectNames
          } : {}
        }
      );
      setCandidates(response.data);
      setFilteredCandidates(response.data);
    } catch (error) {
      console.error('Error updating candidate status:', error);
    }
  };


  const renderMainContent = () => {
    // Operations (client_id=1) has no access to Invoice or Admin
    const effectiveTab = (userRole === 'Operations' && (activeTab === 'invoice' || activeTab === 'admin'))
      ? 'home'
      : activeTab;

    switch (effectiveTab) {
      case "home":
        return (
          <>
            <div className="content-header">
              <h1>Recruiting Overview</h1>
              <div className="header-actions">
                <button className="btn-primary" onClick={() => setActiveTab("candidates")}>New Candidate</button>
                <button className="btn-primary" onClick={() => setActiveTab("timesheet")}>New Timesheet</button>
              </div>
            </div>

            {/* Loading or Error State for Home Data */}
            {isLoadingHomeData && (
              <div className="loading-message">
                <span className="loading-spinner"></span>
                Loading dashboard data...
              </div>
            )}

            {homeDataError && (
              <div className="error-message">
                <span className="error-icon">⚠️</span>
                {homeDataError.message}
                <button
                  className="login-redirect-button"
                  onClick={() => navigate('/login')}
                >
                  Go to Login
                </button>
              </div>
            )}

            {!isLoadingHomeData && !homeDataError && (
              <div className="dashboard-grid">
                <div className="dashboard-card">
                  <h3>Candidates on Payroll</h3>
                  <div className="card-value">{consoleData.payroll_candidates}</div>
                  <div className="card-trend positive">+{consoleData.hired_last_month} this month</div>
                </div>
                <div className="dashboard-card">
                  <h3>Submitted for Open Roles</h3>
                  <div className="card-value">{consoleData.submit_cvs}</div>
                  <div className="card-trend positive">+{consoleData.submit_last_month} this month</div>
                </div>
                <div className="dashboard-card">
                  <h3>Active Open Roles</h3>
                  <div className="card-value">{consoleData.active_roles || 0}</div>
                  <div className="card-trend positive">+{consoleData.roles_last_month || 0} this month</div>
                </div>
                <div className="dashboard-card">
                  <h3>Total Hours last month</h3>
                  <div className="card-value">{consoleData.invoice_hours}</div>
                  <div className="card-trend neutral">
                    {consoleData.max_invoice_date ? new Date(consoleData.max_invoice_date).toLocaleDateString('en-US', { month: 'long', year: 'numeric' }) : 'No data'}
                  </div>
                </div>
              </div>
            )}
 
            <div className="recent-activity">
              <h2>Recent Activity</h2>
              <div className="activity-list">
                {activityData.map((activity, index) => (
                  <div key={index} className="activity-item">
                    <div className="activity-icon">
                      {getActivityIcon(activity.title)}
                    </div>
                    <div className="activity-content">
                      <div className="activity-title">{activity.title}</div>
                      <div className="activity-meta">{activity.name} • {activity.days_ago} days ago</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        );
      case "candidates":
        return <AddCandidatePage />;
      case "open_roles":
        return <AddOpenRolesPage />;
      case "timesheet":
        return <InvoicePage />;
      case "invoice":
        return <SelectInvoicePage />;
      case "sow":
        return <SowPage />;
      case "admin":
        return <AdminPage />;
      case "client_console":
        return (
          <>
            <div className="content-header">
              <h1>Rayze Overview</h1>
              <div className="search-container">
                {userRole !== 'Client' && (
                  <div className="client-search">
                    <select
                      value={selectedClientId || ''}
                      onChange={handleClientChange}
                      className="filter-input"
                    >
                      <option value="">Select client...</option>
                      {clients.map(client => (
                        <option key={client.id} value={client.id}>
                          {client.name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                {userRole !== 'Client' && (
                  <div className="project-search">
                    <div className="multi-select-container">
                      <div 
                        className={`multi-select-header ${isProjectDropdownOpen ? 'open' : ''}`}
                        onClick={toggleProjectDropdown}
                      >
                        <span className="multi-select-label">
                          {isProjectSearchEnabled ? "Select projects..." : "Select a client first..."}
                        </span>
                        {selectedProjectIds.length > 0 && (
                          <span className="selected-count">({selectedProjectIds.length} selected)</span>
                        )}
                      </div>
                      {isProjectDropdownOpen && (
                        <div className="multi-select-dropdown">
                          {(isProjectSearchEnabled && projects.length > 0) ? (
                            <div className="project-checkboxes">
                              {projects.map(project => (
                                <label key={project.id} className="project-checkbox">
                                  <input
                                    type="checkbox"
                                    value={project.id}
                                    checked={selectedProjectIds.includes(project.id)}
                                    onChange={handleProjectChange}
                                    className="project-checkbox-input"
                                  />
                                  <span className="project-checkbox-label">{project.name}</span>
                                </label>
                              ))}
                            </div>
                          ) : (
                            <div className="no-projects">
                              No projects found
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {userRole === 'Client' && selectedProjectIds.length > 0 && (
                  <div className="selected-projects-display">
                    <span className="projects-label">Selected Projects: </span>
                    <span className="projects-list">{projectSearch}</span>
                  </div>
                )}
              </div>
            </div>

            <div className="header-actions" style={{ marginTop: '16px', marginBottom: '16px' }}>
              <button
                className="interview-status-button"
                style={{
                  backgroundColor: '#3b82f6',
                  color: 'white',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontSize: '11px',
                  fontWeight: 500,
                  border: 'none',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap'
                }}
                onClick={handleOpenMeetingSetupModal}
              >
                Fast Meeting Setup
              </button>
            </div>

            {/* Loading State */}
            {isLoadingClientConsole && (
              <div className="loading-message">
                <span className="loading-spinner"></span>
                Loading client console data...
              </div>
            )}

            {/* Error State */}
            {clientConsoleError && (
              <div className="error-message">
                <span className="error-icon">⚠️</span>
                {clientConsoleError.message}
                <button
                  className="login-redirect-button"
                  onClick={() => navigate('/login')}
                >
                  Go to Login
                </button>
              </div>
            )}

            {!isLoadingClientConsole && !clientConsoleError && (
            <>
            <div className="dashboard-grid">
              <div className="dashboard-card">
                <h3>Active Open Roles</h3>
                <div className="card-value">
                  {consoleData.active_client_roles || 0}
                </div>
                <div className="card-trend positive">
                  +{consoleData.active_client_roles_last30 || 0} this month
                </div>
              </div>
              <div className="dashboard-card">
                <h3>Active CVs</h3>
                <div className="card-value">
                  {consoleData.submit_client_cvs || 0}
                </div>
                <div className="card-trend positive">
                  +{consoleData.submit_client_cvs_last30 || 0} this month
                </div>
              </div>
              {userRole === 'ADMIN' && (
                <>
                  <div className="dashboard-card">
                    <h3>Rayze on Payroll</h3>
                    <div className="card-value">
                      {consoleData.total_active_eng || 0}
                    </div>
                    <div className="card-trend positive">
                      +{consoleData.total_active_eng_last30 || 0} this month
                    </div>
                  </div>
                  <div className="dashboard-card">
                    <h3>Hired last 30 days</h3>
                    <div className="card-value">
                      {consoleData.total_active_eng_last30 || 0}
                    </div>
                    <div className="card-trend positive">
                      +{consoleData.total_active_eng_last30 || 0} this month
                    </div>
                  </div>
                </>
              )}
            </div>

            {/* Open Candidates Section */}
            <div className="dashboard-section">
              <div className="section-header">
                <h2 style={{ color: 'var(--theme-color)' }}>Your Input Required</h2>
                <div className="filters">
                  <input
                    type="text"
                    placeholder="Filter by name"
                    value={inputRequiredFilters.name}
                    onChange={(e) => handleInputRequiredFilterChange(e, 'name')}
                    className="filter-input"
                  />
                  <input
                    type="text"
                    placeholder="Filter by Open Role"
                    value={inputRequiredFilters.role}
                    onChange={(e) => handleInputRequiredFilterChange(e, 'role')}
                    className="filter-input"
                  />
                  <input
                    type="text"
                    placeholder="Filter by location"
                    value={inputRequiredFilters.location}
                    onChange={(e) => handleInputRequiredFilterChange(e, 'location')}
                    className="filter-input"
                  />
                </div>
              </div>
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: '140px' }}>Click to Proceed</th>
                      <th style={{ width: '60px' }}>Decline</th>
                      <th>Name</th>
                      <th>Open Role</th>
                      <th>Candidate Location</th>
                      <th>Interview Status</th>
                      <th>Confirmed Interview</th>
                      <th>Days Old</th>
                      <th>CV</th>
                      <th>Interview Evaluation</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredInputRequiredCandidates
                      .filter(candidate => {
                        // Only show candidates with these statuses
                        const validStatus = candidate.status === 'Submitted' ||
                          candidate.status === 'Interview Requested' ||
                          candidate.status === 'Interview Confirmed' ||
                          candidate.status === 'Ready to Hire';

                        if (!validStatus) return false;

                        // If user is Recruiter, only show candidates with matching recruiter_id
                        if (userRole === 'Recruiter') {
                          const userData = JSON.parse(sessionStorage.getItem('user'));
                          return candidate.recruiter_id === userData.client_id;
                        }

                        return true;
                      })
                      .map(candidate => (
                        <tr key={candidate.id}>
                          <td>
                            <button
                              className="interview-status-button"
                              style={{
                                backgroundColor: candidate.status === 'Submitted' ? '#f59e0b' : 
                                  candidate.status === 'Interview Requested' ? '#9333ea' :
                                  candidate.status.includes('Confirmed') ? '#9333ea' :
                                  candidate.status === 'Ready to Hire' ? '#22c55e' : '#3b82f6',
                                color: 'white'
                              }}
                              onClick={(e) => handleProceedClick(e, candidate)}
                            >
                              {candidate.status}
                            </button>
                          </td>
                          <td>
                            <button 
                              className="action-button decline"
                              onClick={(e) => handleDeclineClick(e, candidate)}
                            >
                              X
                            </button>
                          </td>
                          <td>{candidate.name || '-'}</td>
                          <td>{candidate.role || '-'}</td>
                          <td>{candidate.location || '-'}</td>
                          <td>
                            <span className={`status-badge ${candidate.status?.toLowerCase()}`}>
                              {candidate.status || '-'}
                            </span>
                          </td>
                          <td>
                            {candidate.interview_confirmed_on ? (
                              <span style={{
                                color: new Date(candidate.interview_confirmed_on) >= new Date() ? 'var(--theme-color)' : '#ef4444'
                              }}>
                                {new Date(candidate.interview_confirmed_on).toLocaleDateString()} {new Date(candidate.interview_confirmed_on).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', timeZone: 'America/New_York'})} EDT
                              </span>
                            ) : '-'}
                          </td>
                          <td>
                            {candidate.submitted_on ? 
                              Math.floor((new Date() - new Date(candidate.submitted_on)) / (1000 * 60 * 60 * 24)) : 
                              '-'
                            }
                          </td>
                          <td>
                            {candidate.cv_link && (
                              <button 
                                className="cv-link"
                                onClick={() => window.open(candidate.cv_link, '_blank')}
                              >
                                View CV
                              </button>
                            )}
                          </td>
                          <td>
                            {(candidate.match_score || candidate.test_score || candidate.event_id) ? (
                              <button
                                type="button"
                                className="view-match-score"
                                onClick={(e) => handleInterviewEvaluate(e, candidate)}
                              >
                                AI Evaluation
                              </button>
                            ) : '-'}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Open Roles Section */}
            <div className="dashboard-section">
              <div className="section-header">
                <h2>Open Roles</h2>
                <div className="filters">
                  <input
                    type="text"
                    placeholder="Filter by role description"
                    value={openRolesFilters.role_desc}
                    onChange={(e) => handleOpenRolesFilterChange(e, 'role_desc')}
                    className="filter-input"
                  />
                </div>
              </div>
              <div className="table-container">
                <table>
                  <thead>
                    <tr>
                      <th style={{ textAlign: 'left', width: '60ch', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Role Description</th>
                      <th style={{ textAlign: 'left', width: '40ch', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>Role Location</th>
                      <th style={{ textAlign: 'left', width: '40ch' }}># Candidates Submitted</th>
                      <th style={{ textAlign: 'left', width: '40ch' }}>Days Old</th>
                      <th style={{ textAlign: 'left', width: '40ch' }}>Role Posted On</th>
                      <th style={{ textAlign: 'left', width: '40ch' }}>JD Link</th>
                      <th style={{ textAlign: 'left', width: '40ch' }}>Role Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredOpenRoles.map(role => (
                      <tr key={`${role.id}-${role.role_desc}`}>
                        <td style={{ textAlign: 'left', width: '60ch', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{role.role_desc || '-'}</td>
                        <td style={{ width: '40ch', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{role.location || '-'}</td>
                        <td style={{ width: '40ch' }}>{role.num_applicants || 0}</td>
                        <td style={{ width: '40ch' }}>
                          {role.posted_date ? 
                            Math.floor((new Date() - new Date(role.posted_date)) / (1000 * 60 * 60 * 24)) : 
                            '-'
                          }
                        </td>
                        <td style={{ width: '40ch' }}>{role.posted_date || '-'}</td>
                        <td style={{ width: '40ch' }}>
                          {role.job_desc_link ? (
                            <button 
                              className="cv-link"
                              onClick={(e) => handleJDClick(e, role.job_desc_link)}
                            >
                              View JD
                            </button>
                          ) : '-'}
                        </td>
                        <td style={{ width: '40ch' }}>
                          <span className={`status-badge ${role.status?.toLowerCase()}`}>
                            {role.status || '-'}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>


            {/* Hired Candidates Section */}
            <div className="dashboard-section" style={{ marginTop: '2rem' }}>
              <div className="section-header">
                <h2>Hired Candidates</h2>
                <div className="filters">
                  <input
                    type="text"
                    placeholder="Filter by name"
                    value={filters.name}
                    onChange={(e) => handleFilterChange(e, 'name')}
                    className="filter-input"
                  />
                  <input
                    type="text"
                    placeholder="Filter by Current Role"
                    value={filters.role}
                    onChange={(e) => handleFilterChange(e, 'role')}
                    className="filter-input"
                  />
                  <input
                    type="text"
                    placeholder="Filter by location"
                    value={filters.location}
                    onChange={(e) => handleFilterChange(e, 'location')}
                    className="filter-input"
                  />
                </div>
              </div>
              <div className="table-container">
                <table style={{ width: '100%', tableLayout: 'fixed' }}>
                  <thead>
                    <tr>
                      <th style={{ width: '60px', textAlign: 'left' }}>Name</th>
                      <th style={{ width: '60px', textAlign: 'left' }}>Current Role</th>
                      <th style={{ width: '40px', textAlign: 'left' }}>Location</th>
                      <th style={{ width: '40px', textAlign: 'left' }}>Status</th>
                      <th style={{ width: '40px', textAlign: 'left' }}>CV</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredCandidates
                      .filter(candidate => {
                        // Only show Hired candidates
                        if (candidate.status !== 'Hired') return false;

                        // If user is Recruiter, only show candidates with matching recruiter_id
                        if (userRole === 'Recruiter') {
                          const userData = JSON.parse(sessionStorage.getItem('user'));
                          //console.log(candidate.recruiter_id, userData.client_id);
                          return candidate.recruiter_id === userData.client_id;
                        }

                        return true;
                      })
                      .map(candidate => (
                      <tr key={candidate.id}>
                        <td style={{ width: '60px', textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{candidate.name || '-'}</td>
                        <td style={{ width: '60px', textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{candidate.role || '-'}</td>
                        <td style={{ width: '40px', textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{candidate.location || '-'}</td>
                        <td style={{ width: '40px', textAlign: 'left' }}>
                          <span className={`status-badge ${candidate.status?.toLowerCase()}`}>
                            {candidate.status || '-'}
                          </span>
                        </td>
                        <td style={{ width: '40px', textAlign: 'left' }}>
                          {candidate.cv_link && (
                            <button 
                              className="cv-link"
                              onClick={() => window.open(candidate.cv_link, '_blank')}
                            >
                              View CV
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            </>
            )}
          </>
        );
      }
  };

  // If user role is not set yet, don't render anything
  if (!userRole) {
    return null;
  }

  return (
    <div className="rayze-console">
      <div className="console-header">
        <div className="logo-container" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          <img src="/images/logo-text-black.svg" alt="Rayze" className="logo" />
        </div>
        {user && <UserAvatar user={user} onClick={handleAvatarClick} />}
      </div>
      <div className="console-content">
        <div className="sidebar">
          <nav className="main-nav">
            {userRole === 'ADMIN' && (
              <div className="nav-section">
                <h3>Main</h3>
                <ul>
                  <li className={activeTab === "home" ? "active" : ""} onClick={() => setActiveTab("home")}>
                    <i className="fas fa-home"></i>
                    Console Home
                  </li>
                  <li className={activeTab === "candidates" ? "active" : ""} onClick={() => setActiveTab("candidates")}>
                    <i className="fas fa-users"></i>
                    Candidates
                  </li>
                  <li className={activeTab === "open_roles" ? "active" : ""} onClick={() => setActiveTab("open_roles")}>
                    <i className="fas fa-chart-line"></i>
                    Open Roles
                  </li>
                  <li className={activeTab === "timesheet" ? "active" : ""} onClick={() => setActiveTab("timesheet")}>
                    <i className="fas fa-users"></i>
                    Timesheets
                  </li>
                  <li className={activeTab === "client_console" ? "active" : ""} onClick={() => setActiveTab("client_console")}>
                    <i className="fas fa-book"></i>
                    Client Console
                  </li>
                </ul>
              </div>
            )}

            {userRole === 'Recruiter' && (
              <div className="nav-section">
                <h3>Main</h3>
                <ul>
                  <li className="disabled" style={{ 
                    opacity: 0.5, 
                    cursor: 'not-allowed',
                    pointerEvents: 'none'
                  }}>
                    <i className="fas fa-users"></i>
                    Candidates
                  </li>
                  <li className="disabled" style={{ 
                    opacity: 0.5, 
                    cursor: 'not-allowed',
                    pointerEvents: 'none'
                  }}>
                    <i className="fas fa-chart-line"></i>
                    Open Roles
                  </li>
                  <li className={activeTab === "timesheet" ? "active" : ""} onClick={() => setActiveTab("timesheet")}>
                    <i className="fas fa-users"></i>
                    Timesheets
                  </li>
                  <li className="disabled" style={{ 
                    opacity: 0.5, 
                    cursor: 'not-allowed',
                    pointerEvents: 'none'
                  }}>
                    <i className="fas fa-book"></i>
                    Client Console
                  </li>
                </ul>
              </div>
            )}

            {userRole === 'Operations' && (
              <div className="nav-section">
                <h3>Main</h3>
                <ul>
                  <li className={activeTab === "home" ? "active" : ""} onClick={() => setActiveTab("home")}>
                    <i className="fas fa-home"></i>
                    Console Home
                  </li>
                  <li className={activeTab === "candidates" ? "active" : ""} onClick={() => setActiveTab("candidates")}>
                    <i className="fas fa-users"></i>
                    Candidates
                  </li>
                  <li className={activeTab === "open_roles" ? "active" : ""} onClick={() => setActiveTab("open_roles")}>
                    <i className="fas fa-chart-line"></i>
                    Open Roles
                  </li>
                  <li className={activeTab === "timesheet" ? "active" : ""} onClick={() => setActiveTab("timesheet")}>
                    <i className="fas fa-users"></i>
                    Timesheets
                  </li>
                  <li className={activeTab === "client_console" ? "active" : ""} onClick={() => setActiveTab("client_console")}>
                    <i className="fas fa-book"></i>
                    Client Console
                  </li>
                </ul>
              </div>
            )}

            {userRole === 'Client' && (
              <div className="nav-section">
                <h3>Client Portal</h3>
                <ul>
                  <li className="active">
                    <i className="fas fa-book"></i>
                    Client Console
                  </li>
                </ul>
              </div>
            )}

            {userRole === 'ADMIN' && (
              <div className="nav-section">
                <h3>Management</h3>
                <ul>
                  <li className={activeTab === "invoice" ? "active" : ""} onClick={() => setActiveTab("invoice")}>
                    <i className="fas fa-project-diagram"></i>
                    Invoice
                  </li>
                  <li className={activeTab === "sow" ? "active" : ""} onClick={() => setActiveTab("sow")}>
                    <i className="fas fa-file-contract"></i>
                    SOW
                  </li>
                  <li className={activeTab === "admin" ? "active" : ""} onClick={() => setActiveTab("admin")}>
                    <i className="fas fa-book"></i>
                    Admin
                  </li>
                  <li className="disabled" style={{ 
                    opacity: 0.5, 
                    cursor: 'not-allowed',
                    pointerEvents: 'none'
                  }}>
                    <i className="fas fa-code"></i>
                    Recruiting
                  </li>
                  <li className="disabled" style={{ 
                    opacity: 0.5, 
                    cursor: 'not-allowed',
                    pointerEvents: 'none'
                  }}>
                    <i className="fas fa-headset"></i>
                    Operations
                  </li>
                  <li className="disabled" style={{ 
                    opacity: 0.5, 
                    cursor: 'not-allowed',
                    pointerEvents: 'none'
                  }}>
                    <i className="fas fa-headset"></i>
                    Finance
                  </li>
                  <li className="disabled" style={{ 
                    opacity: 0.5, 
                    cursor: 'not-allowed',
                    pointerEvents: 'none'
                  }}>
                    <i className="fas fa-headset"></i>
                    Payroll
                  </li>
                </ul>
              </div>
            )}
          </nav>
        </div>

        <div className="main-content">
          {renderMainContent()}
        </div>
      </div>

      {/* Match Score Modal */}
      {showMatchScoreModal && (
        <div className="modal-overlay" onClick={handleCloseMatchScoreModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Candidate Match Score</h2>
              <button className="close-button" onClick={handleCloseMatchScoreModal}>×</button>
            </div>
            <div className="modal-body">
              <div dangerouslySetInnerHTML={{ __html: matchScoreResult }} />
            </div>
            <div className="modal-footer">
              <button className="modal-button" onClick={handleCloseMatchScoreModal}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Interview Evaluation Modal */}
      {showInterviewEvalModal && (
        <div className="modal-overlay" onClick={handleCloseInterviewEvalModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Interview Evaluation</h2>
              <button className="close-button" onClick={handleCloseInterviewEvalModal}>×</button>
            </div>
            <div className="modal-body">
              {isLoadingEvaluation ? (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <div className="spinner" style={{
                    border: '4px solid #f3f3f3',
                    borderTop: '4px solid var(--theme-color)',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    animation: 'spin 1s linear infinite',
                    margin: '0 auto 20px'
                  }}></div>
                  <p style={{ color: 'var(--theme-color)', fontWeight: 'bold' }}>
                    {evaluationStatus}
                  </p>
                </div>
              ) : evaluationStatus ? (
                <div style={{ padding: '20px', textAlign: 'center', color: '#ef4444' }}>
                  {evaluationStatus}
                </div>
              ) : (
                <div dangerouslySetInnerHTML={{ __html: interviewEvalResult }} />
              )}
            </div>
            <div className="modal-footer">
              <button className="modal-button" onClick={handleCloseInterviewEvalModal}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Decline Modal */}
      {showDeclineModal && (
        <div className="modal-overlay" onClick={handleCloseDeclineModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Confirm Decline</h2>
              <button className="close-button" onClick={handleCloseDeclineModal}>×</button>
            </div>
            <div className="modal-body">
              <p>Confirm  {selectedCandidate?.name} is declined from the hiring process.</p>
              <div className="feedback-section">
                <label htmlFor="declineFeedback">Reason for Decline:</label>
                <select
                  id="declineFeedback"
                  value={declineFeedback}
                  onChange={(e) => setDeclineFeedback(e.target.value)}
                  className="feedback-select"
                >
                  <option value="">Select a reason</option>
                  <option value="Skills mismatch">Skills mismatch</option>
                  <option value="Not strong in technical skills">Not strong in technical skills</option>
                  <option value="Not strong in communications">Not strong in communications</option>
                  <option value="Location mismatch">Location mismatch</option>
                  <option value="Culture mismatch">Culture mismatch</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <button 
                className="modal-button cancel" 
                onClick={handleCloseDeclineModal}
              >
                Cancel
              </button>
              <button 
                className="modal-button confirm" 
                onClick={handleDeclineConfirm}
                disabled={!declineFeedback}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Meeting Setup Modal */}
      {showMeetingSetupModal && (
        <div className="modal-overlay" onClick={handleCloseMeetingSetupModal}>
          <div className="modal-content schedule-modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Meeting Setup</h2>
              <button className="close-button" onClick={handleCloseMeetingSetupModal}>×</button>
            </div>
            <div className="modal-body">
              <div className="contact-info-section">
                <div className="contact-inputs">
                  <div className="input-group">
                    <label htmlFor="meeting-from-email">From email:</label>
                    <input
                      type="email"
                      id="meeting-from-email"
                      value={meetingSetupFrom}
                      onChange={(e) => setMeetingSetupFrom(e.target.value)}
                      className="schedule-input"
                      placeholder="sender@example.com"
                    />
                  </div>
                  <div className="input-group">
                    <label htmlFor="meeting-to">To:</label>
                    <input
                      type="text"
                      id="meeting-to"
                      value={meetingSetupTo}
                      onChange={(e) => setMeetingSetupTo(e.target.value)}
                      className="schedule-input"
                      placeholder="participant1@example.com, participant2@example.com"
                    />
                    <small style={{ color: '#6b7280', fontSize: '12px' }}>Comma separated list of participants.</small>
                  </div>
                  <div className="input-group">
                    <label htmlFor="meeting-subject">Subject:</label>
                    <input
                      type="text"
                      id="meeting-subject"
                      value={meetingSetupSubject}
                      onChange={(e) => setMeetingSetupSubject(e.target.value)}
                      className="schedule-input"
                      placeholder="Topic of the meeting"
                    />
                  </div>
                  <div className="input-group">
                    <label htmlFor="meeting-date">Date:</label>
                    <input
                      type="date"
                      id="meeting-date"
                      value={meetingSetupDate}
                      onChange={(e) => setMeetingSetupDate(e.target.value)}
                      className="schedule-input"
                    />
                  </div>
                  <div className="input-group">
                    <label htmlFor="meeting-start-time">Start time:</label>
                    <input
                      type="time"
                      id="meeting-start-time"
                      value={meetingSetupStartTime}
                      onChange={(e) => setMeetingSetupStartTime(e.target.value)}
                      className="schedule-input"
                    />
                  </div>
                  <div className="input-group">
                    <label htmlFor="meeting-end-time">End time:</label>
                    <input
                      type="time"
                      id="meeting-end-time"
                      value={meetingSetupEndTime}
                      onChange={(e) => setMeetingSetupEndTime(e.target.value)}
                      className="schedule-input"
                    />
                  </div>
                  <div className="input-group">
                    <label htmlFor="meeting-timezone">Timezone:</label>
                    <select
                      id="meeting-timezone"
                      value={meetingSetupTimezone}
                      onChange={(e) => setMeetingSetupTimezone(e.target.value)}
                      className="schedule-input"
                    >
                      {!['America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles', 'America/Phoenix', 'America/Bogota', 'America/Mexico_City', 'Europe/London', 'Europe/Paris', 'Asia/Tokyo', 'Asia/Shanghai', 'Asia/Singapore', 'Asia/Kolkata', 'Australia/Sydney', 'Australia/Melbourne', 'UTC'].includes(meetingSetupTimezone) && (
                        <option value={meetingSetupTimezone}>{meetingSetupTimezone} (your timezone)</option>
                      )}
                      <option value="America/New_York">Eastern Time (New York)</option>
                      <option value="America/Chicago">Central Time (Chicago)</option>
                      <option value="America/Denver">Mountain Time (Denver)</option>
                      <option value="America/Los_Angeles">Pacific Time (Los Angeles)</option>
                      <option value="America/Phoenix">Mountain Time (Phoenix)</option>
                      <option value="America/Bogota">Bogota</option>
                      <option value="America/Mexico_City">Mexico City</option>
                      <option value="Europe/London">London</option>
                      <option value="Europe/Paris">Paris</option>
                      <option value="Asia/Tokyo">Tokyo</option>
                      <option value="Asia/Shanghai">Shanghai</option>
                      <option value="Asia/Singapore">Singapore</option>
                      <option value="Asia/Kolkata">India</option>
                      <option value="Australia/Sydney">Sydney</option>
                      <option value="Australia/Melbourne">Melbourne</option>
                      <option value="UTC">UTC</option>
                    </select>
                    <small style={{ color: '#6b7280', fontSize: '12px' }}>Defaults to your browser timezone.</small>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="modal-button cancel"
                onClick={handleCloseMeetingSetupModal}
              >
                Cancel
              </button>
              <button
                className="modal-button confirm"
                onClick={handleCreateMeeting}
                disabled={!isMeetingSetupValid() || isCreatingMeeting}
              >
                {isCreatingMeeting ? 'Sending...' : 'Create Meeting'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Schedule Interview Modal */}
      {showScheduleModal && (
        <div className="modal-overlay" onClick={handleCloseScheduleModal}>
          <div className="modal-content schedule-modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <h2>Schedule Interview</h2>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px' }}>
                  <input
                    type="checkbox"
                    checked={useFastMeetingSetup}
                    onChange={(e) => {
                      const val = e.target.checked;
                      setUseFastMeetingSetup(val);
                      localStorage.setItem('useFastMeetingSetup', String(val));
                    }}
                  />
                  Fast Meeting Setup
                </label>
              </div>
              <button className="close-button" onClick={handleCloseScheduleModal}>×</button>
            </div>
            <div className="modal-body">
              {useFastMeetingSetup ? (
                <div className="contact-info-section">
                  <div className="contact-inputs">
                    <div className="input-group">
                      <label htmlFor="schedule-meeting-from-email">From email:</label>
                      <input
                        type="email"
                        id="schedule-meeting-from-email"
                        value={meetingSetupFrom}
                        onChange={(e) => setMeetingSetupFrom(e.target.value)}
                        className="schedule-input"
                        placeholder="sender@example.com"
                      />
                    </div>
                    <div className="input-group">
                      <label htmlFor="schedule-meeting-to">To:</label>
                      <input
                        type="text"
                        id="schedule-meeting-to"
                        value={meetingSetupTo}
                        onChange={(e) => setMeetingSetupTo(e.target.value)}
                        className="schedule-input"
                        placeholder="participant1@example.com, participant2@example.com"
                      />
                      <small style={{ color: '#6b7280', fontSize: '12px' }}>Comma separated list of participants.</small>
                    </div>
                    <div className="input-group">
                      <label htmlFor="schedule-meeting-subject">Subject:</label>
                      <input
                        type="text"
                        id="schedule-meeting-subject"
                        value={meetingSetupSubject}
                        onChange={(e) => setMeetingSetupSubject(e.target.value)}
                        className="schedule-input"
                        placeholder="Topic of the meeting"
                      />
                    </div>
                    <div className="input-group">
                      <label htmlFor="schedule-meeting-date">Date:</label>
                      <input
                        type="date"
                        id="schedule-meeting-date"
                        value={meetingSetupDate}
                        onChange={(e) => setMeetingSetupDate(e.target.value)}
                        className="schedule-input"
                      />
                    </div>
                    <div className="input-group">
                      <label htmlFor="schedule-meeting-start-time">Start time:</label>
                      <input
                        type="time"
                        id="schedule-meeting-start-time"
                        value={meetingSetupStartTime}
                        onChange={(e) => setMeetingSetupStartTime(e.target.value)}
                        className="schedule-input"
                      />
                    </div>
                    <div className="input-group">
                      <label htmlFor="schedule-meeting-end-time">End time:</label>
                      <input
                        type="time"
                        id="schedule-meeting-end-time"
                        value={meetingSetupEndTime}
                        onChange={(e) => setMeetingSetupEndTime(e.target.value)}
                        className="schedule-input"
                      />
                    </div>
                    <div className="input-group">
                      <label htmlFor="schedule-meeting-timezone">Timezone:</label>
                      <select
                        id="schedule-meeting-timezone"
                        value={meetingSetupTimezone}
                        onChange={(e) => setMeetingSetupTimezone(e.target.value)}
                        className="schedule-input"
                      >
                        {!['America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles', 'America/Phoenix', 'America/Bogota', 'America/Mexico_City', 'Europe/London', 'Europe/Paris', 'Asia/Tokyo', 'Asia/Shanghai', 'Asia/Singapore', 'Asia/Kolkata', 'Australia/Sydney', 'Australia/Melbourne', 'UTC'].includes(meetingSetupTimezone) && (
                          <option value={meetingSetupTimezone}>{meetingSetupTimezone} (your timezone)</option>
                        )}
                        <option value="America/New_York">Eastern Time (New York)</option>
                        <option value="America/Chicago">Central Time (Chicago)</option>
                        <option value="America/Denver">Mountain Time (Denver)</option>
                        <option value="America/Los_Angeles">Pacific Time (Los Angeles)</option>
                        <option value="America/Phoenix">Mountain Time (Phoenix)</option>
                        <option value="America/Bogota">Bogota</option>
                        <option value="America/Mexico_City">Mexico City</option>
                        <option value="Europe/London">London</option>
                        <option value="Europe/Paris">Paris</option>
                        <option value="Asia/Tokyo">Tokyo</option>
                        <option value="Asia/Shanghai">Shanghai</option>
                        <option value="Asia/Singapore">Singapore</option>
                        <option value="Asia/Kolkata">India</option>
                        <option value="Australia/Sydney">Sydney</option>
                        <option value="Australia/Melbourne">Melbourne</option>
                        <option value="UTC">UTC</option>
                      </select>
                      <small style={{ color: '#6b7280', fontSize: '12px' }}>Defaults to your browser timezone.</small>
                    </div>
                  </div>
                </div>
              ) : (
                <>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    <button
                      style={{
                        backgroundColor: '#3b82f6',
                        color: 'white',
                        padding: '8px 16px',
                        borderRadius: '4px',
                        border: 'none',
                        marginBottom: '16px',
                        cursor: 'pointer'
                      }}
                      onClick={() => {
                        selectedCandidate.status = "Confirmed Fast Track";
                        handleProceedClick(new Event('click'), selectedCandidate);
                        handleCloseScheduleModal();
                        return;
                      }}
                    >
                      Fast Track to Hire
                    </button>
                    <button
                      style={{
                        backgroundColor: '#3b82f6',
                        color: 'white',
                        padding: '8px 16px',
                        borderRadius: '4px',
                        border: 'none',
                        marginBottom: '16px',
                        cursor: 'pointer'
                      }}
                      onClick={handleOpenMeetingSetupModal}
                    >
                      Fast Meeting Setup
                    </button>
                  </div>
                  <p>Please select 3 interview timeslots for the candidate {selectedCandidate?.name}</p>
                  <p style={{ color: '#0066ff' }}>Candidate Location: {selectedCandidate?.location}</p>
                  <p style={{ color: '#0066ff' }}>Please consider the timezone of the candidate</p>
                  <div className="contact-info-section">
                    <h3>Invitees to Interview meeting</h3>
                    <div className="contact-inputs">
                      <div className="input-group">
                        <label htmlFor="candidate-email">Offer timeslot to candidate email:</label>
                        <input
                          type="email"
                          id="candidate-email"
                          value={candidateEmail}
                          onChange={(e) => {
                            const val = e.target.value;
                            const firstEmail = val.includes(',') ? val.split(',')[0].trim() : val;
                            setCandidateEmail(firstEmail);
                          }}
                          className="schedule-input"
                          placeholder="candidate@example.com"
                        />
                        <small style={{ color: '#6b7280', fontSize: '12px' }}>Single email only. Used as TO for the timeslot offer email.</small>
                      </div>
                      <div className="input-group">
                        <label htmlFor="interviewer-emails">Client &amp; Rayze interviewers email:</label>
                        <input
                          type="text"
                          id="interviewer-emails"
                          value={interviewerEmails}
                          onChange={(e) => setInterviewerEmails(e.target.value)}
                          className="schedule-input"
                          placeholder="interviewer1@example.com, interviewer2@example.com"
                        />
                        <small style={{ color: '#6b7280', fontSize: '12px' }}>Comma separated. Included on calendar invite with candidate.</small>
                      </div>
                      <div className="input-group">
                        <label htmlFor="interview-phone">Phone Number:</label>
                        <input
                          type="text"
                          id="interview-phone"
                          value={interviewPhone}
                          onChange={(e) => setInterviewPhone(e.target.value)}
                          className="schedule-input"
                          placeholder="+1-555-123-4567"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="interview-slots">
                    {['prio1', 'prio2', 'prio3'].map((priority, index) => (
                      <div key={priority} className="interview-slot">
                        <h3>Priority {index + 1} Interview Time</h3>
                        <div className="slot-inputs">
                          <div className="input-group">
                            <label htmlFor={`${priority}-date`}>Date:</label>
                            <input
                              type="date"
                              id={`${priority}-date`}
                              value={interviewSlots[priority].date}
                              onChange={(e) => handleInterviewSlotChange(priority, 'date', e.target.value)}
                              className="schedule-input"
                            />
                          </div>
                          <div className="input-group">
                            <label htmlFor={`${priority}-time`}>Time:</label>
                            <input
                              type="time"
                              id={`${priority}-time`}
                              value={interviewSlots[priority].time}
                              onChange={(e) => handleInterviewSlotChange(priority, 'time', e.target.value)}
                              className="schedule-input"
                            />
                          </div>
                          <div className="input-group">
                            <label htmlFor={`${priority}-timezone`}>Timezone:</label>
                            <select
                              id={`${priority}-timezone`}
                              value={interviewSlots[priority].timezone}
                              onChange={(e) => handleInterviewSlotChange(priority, 'timezone', e.target.value)}
                              className="schedule-input"
                            >
                              <option value="America/New_York">Eastern Time (New York)</option>
                              <option value="America/Chicago">Central Time (Chicago)</option>
                              <option value="America/Denver">Mountain Time (Denver)</option>
                              <option value="America/Los_Angeles">Pacific Time (Los Angeles)</option>
                              <option value="America/Chicago">Central Time (Austin)</option>
                              <option value="America/Phoenix">Mountain Time (Phoenix)</option>
                              <option value="America/Los_Angeles">Pacific Time (Seattle)</option>
                              <option value="America/Chicago">Central Time (Dallas)</option>
                              <option value="America/Chicago">Central Time (Houston)</option>
                              <option value="America/Los_Angeles">Pacific Time (San Francisco)</option>
                              <option value="America/Los_Angeles">Pacific Time (San Diego)</option>
                              <option value="America/New_York">Eastern Time (Boston)</option>
                              <option value="America/Chicago">Central Time (New Orleans)</option>
                              <option value="America/New_York">Eastern Time (Philadelphia)</option>
                              <option value="America/Bogota">Bogota</option>
                              <option value="America/Bogota">Medellin</option>
                              <option value="America/Mexico_City">Mexico City</option>
                              <option value="Europe/London">London</option>
                              <option value="Europe/Paris">Paris</option>
                              <option value="Asia/Tokyo">Tokyo</option>
                              <option value="Asia/Shanghai">Shanghai</option>
                              <option value="Asia/Singapore">Singapore</option>
                              <option value="Asia/Kolkata">Mumbai</option>
                              <option value="Asia/Kolkata">Hyderabad</option>
                              <option value="Asia/Kolkata">Delhi</option>
                              <option value="Asia/Kolkata">Kolkata</option>
                              <option value="Asia/Kolkata">Chennai</option>
                              <option value="Asia/Kolkata">Bengaluru</option>
                              <option value="Asia/Kolkata">Jaipur</option>
                              <option value="Asia/Kolkata">Ahmedabad</option>
                              <option value="Asia/Kolkata">Pune</option>
                              <option value="Australia/Sydney">Sydney</option>
                              <option value="Australia/Melbourne">Melbourne</option>
                              <option value="Australia/Perth">Perth</option>
                            </select>
                          </div>
                        </div>
                        {convertedTimes[priority] && (
                          <div style={{ marginTop: '8px', padding: '8px', backgroundColor: '#f0f8ff', borderRadius: '4px', fontSize: '14px', color: '#0066cc' }}>
                            <strong>Candidate Location Time:</strong> {convertedTimes[priority]} ({selectedCandidate?.location || selectedCandidate?.timezone || 'Unknown timezone'})
                          </div>
                        )}
                        {convertingTimes[priority] && (
                          <div style={{ marginTop: '8px', padding: '8px', backgroundColor: '#fff3cd', borderRadius: '4px', fontSize: '14px', color: '#856404' }}>
                            <strong>Converting time...</strong>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
            <div className="modal-footer">
              <button
                className="modal-button cancel"
                onClick={handleCloseScheduleModal}
              >
                Cancel
              </button>
              <button
                className="modal-button confirm"
                onClick={useFastMeetingSetup ? handleCreateMeeting : handleScheduleInterview}
                disabled={useFastMeetingSetup ? (!isMeetingSetupValid() || isCreatingMeeting) : !isScheduleButtonEnabled()}
              >
                {useFastMeetingSetup ? (isCreatingMeeting ? 'Sending...' : 'Schedule Interview') : 'Schedule Interview'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Job Description Modal */}
      {showJDModal && (
        <div className="modal-overlay" onClick={handleCloseJDModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '80%', maxHeight: '80%', overflow: 'auto' }}>
            <div className="modal-header">
              <h2>Job Description</h2>
              <button className="close-button" onClick={handleCloseJDModal}>×</button>
            </div>
            <div className="modal-body" style={{ maxHeight: '70vh', overflow: 'auto' }}>
              <div dangerouslySetInnerHTML={{ __html: currentJDContent }} />
            </div>
            <div className="modal-footer">
              <button className="modal-button" onClick={handleCloseJDModal}>Close</button>
            </div>
          </div>
        </div>
      )}

      <ProfileModal
        isOpen={profileModalOpen}
        onRequestClose={() => setProfileModalOpen(false)}
        user={user}
        onSave={handleProfileSave}
      />
    </div>
  )
}
